import { IPressureIconProps } from '../../components/Icons/WeatherIcons/AirPressure/AirPressureIcon';

// Air pressure thresholds in pascals.
const LOW_PRESSURE_MAX_PA = 100500;
const MEDIUM_PRESSURE_MAX_PA = 101500;

export const getPressureIconValue = (value: number): IPressureIconProps['value'] => {
  if (value < LOW_PRESSURE_MAX_PA) {
    return 'LOW';
  }
  if (value < MEDIUM_PRESSURE_MAX_PA) {
    return 'MEDIUM';
  }
  return 'HIGH';
};
